import { render } from "./TargetingTypeFilterItem.vue?vue&type=template&id=605e2aa8"
import script from "./TargetingTypeFilterItem.vue?vue&type=script&lang=js"
export * from "./TargetingTypeFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__